/*
  California Prop 65 disclosure gate.

  The disclosure blocks are rendered with `hidden` set, and are revealed only for a visitor whose
  IP geolocates to California, US. This reproduces live's behaviour unchanged, including the
  `ipapi.co` lookup and the silent failure mode: if the request fails, is blocked, or returns
  anything unexpected, the disclosures stay hidden.
*/
(function () {
  var disclosures = document.querySelectorAll('.prop65-disclosure');
  if (!disclosures.length) return;

  fetch('https://ipapi.co/json/')
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (data.region_code === 'CA' && data.country_code === 'US') {
        disclosures.forEach(function (element) {
          element.hidden = false;
        });
      }
    })
    .catch(function () {});
})();
